import { Component, OnInit, Input } from '@angular/core';
import { PreinscriptionService } from '@app/services/preinscription.service';
import { PermissionService } from '@app/services/permission.service';
import { PlatformService } from '@app/services/platform.service';
import { Router } from '@angular/router';
import { FamilyService, FormConfigService } from '@app/services';
import { filter, takeUntil, tap, switchMap, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PreInscription } from '@app/models/pre-inscription';

@Component({
  selector: 'app-user-preinscriptions',
  templateUrl: './preinscription-list.component.html',
  styleUrls: ['./preinscription-list.component.scss']
})
export class PreinscriptionListComponent implements OnInit {

  preinscriptions: PreInscription[];

  formParts: any[];
  readOnly: boolean;
  permToCreate: boolean;

  loading = false;
  onDestroy$ = new Subject();

  constructor(
    private preinscriptionService: PreinscriptionService,
    private familyService: FamilyService,
    public platformService: PlatformService,
    public permService: PermissionService,
    private formConfigService: FormConfigService,
    public router: Router
  ) { }

  ngOnInit() {
    this.readOnly = !this.permService.hasPermission('preinscription_edit') || !this.familyService.currentFamily.active;
    this.permToCreate = this.permService.hasPermission('preinscription_create') && this.familyService.currentFamily.active;
    this.loadFormSteps().subscribe(stepNames => this.formParts = stepNames);

    this.familyService.currentFamily$.pipe(
      filter(f => !!f),
      takeUntil(this.onDestroy$),
      tap(_ => { this.preinscriptions = null; this.loading = false; }),
      switchMap(_ => this.loadPreinscriptions())
    ).subscribe();
  }

  loadPreinscriptions() {
    return this.preinscriptionService.getCurrentFamilyItems().pipe(tap(data => this.preinscriptions = data))
  }

  loadFormSteps() {
    const filteredSteps = ['InformationsImportantes']; // steps excluded in "read / edit" (not create) modes
    return this.formConfigService.getForm('form-pre-inscription').pipe(
      map(steps => steps
        .filter(step => (!filteredSteps.includes(step.stepName)))
        .map(step => ({ stepName: step.stepName, label: step.label }))
      )
    );
  }

  openForm(PreInscriptionId, stepName) {
    this.router.navigate([`/account/preinscription/edit/${PreInscriptionId}/${stepName}`]);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
